import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
const API_ROOT = 'https://newerp.awasthivitality.com';

const Staff = () => {
  const getAuthToken = () => {
    const keys = ['authToken', 'token', 'AUTH_TOKEN', 'api_token', 'auth_token', 'session_token', 'access_token', 'apiToken'];
    for (const key of keys) {
      const ls = window.localStorage?.getItem(key);
      if (ls && ls.trim()) return ls.trim();
      const ss = window.sessionStorage?.getItem(key);
      if (ss && ss.trim()) return ss.trim();
    }

    const jsonKeys = ['auth', 'user', 'session', 'auth_user', 'currentUser'];
    for (const key of jsonKeys) {
      try {
        const ls = window.localStorage?.getItem(key);
        if (ls) {
          const parsed = JSON.parse(ls);
          const token = parsed?.token || parsed?.api_token || parsed?.access_token || parsed?.session_token;
          if (token && String(token).trim()) return String(token).trim();
        }
      } catch (e) {}
      try {
        const ss = window.sessionStorage?.getItem(key);
        if (ss) {
          const parsed = JSON.parse(ss);
          const token = parsed?.token || parsed?.api_token || parsed?.access_token || parsed?.session_token;
          if (token && String(token).trim()) return String(token).trim();
        }
      } catch (e) {}
    }

    const urlToken = new URLSearchParams(window.location.search).get('token');
    if (urlToken && urlToken.trim()) return urlToken.trim();

    const cookieMatch = document.cookie.match(/(?:^|; )(?:auth_token|token|api_token)=([^;]*)/);
    return cookieMatch?.[1] ? decodeURIComponent(cookieMatch[1]) : null;
  };

  const withTokenQuery = (url) => {
    const token = getAuthToken();
    if (!token) return url;

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}token=${encodeURIComponent(token)}`;
  };

  const [invoices, setInvoices] = useState([]);
  const [users, setUsers] = useState([]);
  const [isAdminUser, setIsAdminUser] = useState(false);
  const [apiError, setApiError] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(true);

  // Filter & Pagination States
  const [userId, setUserId] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [detailsMap, setDetailsMap] = useState({});
  
  const [dateSortOrder, setDateSortOrder] = useState('desc'); // default DESC
  const [itemsPerPage] = useState(15);
  const navigate = useNavigate();
  useEffect(() => {
    let retryTimer = null;
    let retryCount = 0;

    const fetchUsers = async () => {
      try {
        const token = getAuthToken();
        if (!token && retryCount < 10) {
          retryCount += 1;
          retryTimer = setTimeout(fetchUsers, 1000);
          return;
        }

        const response = await fetch(withTokenQuery(`${API_ROOT}/public/api/incentive/users`), {
          credentials: 'include'
        });
        const result = await response.json();

        if (result.success && result.data) {
          setUsers(result.data);
          setIsAdminUser(Boolean(result.is_admin));
          setApiError('');

          if (!result.is_admin && result.data.length === 1) {
            setUserId(String(result.data[0].user_id));
          }
        } else {
          setUsers([]);
          setApiError(result.message || 'Unable to load staff list');
        }
      } catch (err) {
        console.error("User fetch error", err);
        setUsers([]);
        setApiError('Failed to load staff list');
      }
    };
    fetchUsers();
    return () => {
      if (retryTimer) clearTimeout(retryTimer);
    };
  }, []);

  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     setLoading(true);
  //     try {
  //       const params = new URLSearchParams();
  //       if (userId) params.append('user_id', userId);
  //       if (fromDate) params.append('from_date', fromDate);
  //       if (toDate) params.append('to_date', toDate);

  //       const response = await fetch(`${API_ROOT}/api/incentive/invoices?${params.toString()}`);
  //       const result = await response.json();

  //       // Invoices are likely the root array or inside .data based on your first screenshot
  //       const data = Array.isArray(result) ? result : (result.data || []);
  //       setInvoices(data.sort((a, b) => parseInt(b.invoice_id) - parseInt(a.invoice_id)));

  //       // Capturing summary stats from the root of the response
  //       setTotalCount(result.total_count || 0);
  //       setTotalAmount(result.total_amount || 0);

  //       setCurrentPage(1);
  //     } catch (err) {
  //       console.error(err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, [userId, fromDate, toDate]);
  useEffect(() => {
    const fetchInvoices = async () => {
      setLoading(true);
      try {
        const params = new URLSearchParams();
        if (userId) params.append('user_id', userId);
        if (fromDate) params.append('from_date', fromDate);
        if (toDate) params.append('to_date', toDate);

        const response = await fetch(withTokenQuery(`${API_ROOT}/api/incentive/invoices?${params.toString()}`), {
          credentials: 'include'
        });
        const result = await response.json();

        const data = Array.isArray(result) ? result : (result.data || []);
const sortedData = data.sort((a, b) => {
  const dateA = new Date(a.invoice_date);
  const dateB = new Date(b.invoice_date);

  return dateSortOrder === 'asc'
    ? dateA - dateB   // ASC
    : dateB - dateA;  // DESC
});

setInvoices(sortedData);
        setTotalCount(result.total_count || 0);
        setTotalAmount(result.total_amount || 0);
        setCurrentPage(1);

        // ✅ Fetch total_quantity for all invoices automatically
     

      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchInvoices();
  }, [userId, fromDate, toDate]);
  useEffect(() => {
  const sorted = [...invoices].sort((a, b) => {
    const dateA = new Date(a.invoice_date);
    const dateB = new Date(b.invoice_date);

    return dateSortOrder === 'asc'
      ? dateA - dateB
      : dateB - dateA;
  });

  setInvoices(sorted);
}, [dateSortOrder]);
const handlePrint = () => {
  const printContent = document.getElementById('sv-table-to-print');
  const WinPrint = window.open('', '', 'width=900,height=650');
  
  WinPrint.document.write('<html><head><title>Print</title>');

  // Include styles
  WinPrint.document.write('<style>');
  WinPrint.document.write(`
    body { font-family: sans-serif; margin: 20px; }
    table { width: 100%; border-collapse: collapse; }
    th, td { border: 1px solid #000; padding: 8px; text-align: center; }
    th { background-color: #f0f0f0; }
    .txt-id { color: #2fb2e7; font-weight: 600; }
    .txt-amount { font-weight: 700; color: #10b981; }
  `);
  WinPrint.document.write('</style></head><body>');
  
  // Write the table
  WinPrint.document.write(printContent.innerHTML);
  WinPrint.document.write('</body></html>');
  
  WinPrint.document.close();
  WinPrint.focus();
  WinPrint.print();
  WinPrint.close();
};
  const fetchInvoiceDetails = async (invoiceId) => {
    if (detailsMap[invoiceId]) {
      setInvoiceDetails(detailsMap[invoiceId]);
      setShowModal(true);
      return;
    }

    try {
      const res = await fetch(withTokenQuery(`${API_ROOT}/public/api/invoice/details/${invoiceId}`), {
        credentials: 'include'
      });
      const data = await res.json();

      if (data.success) {
        // ✅ update qty instantly
        setDetailsMap(prev => ({
          ...prev,
          [invoiceId]: data
        }));

        setInvoiceDetails(data);
        setShowModal(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Pagination Logic
  const totalPages = Math.ceil(invoices.length / itemsPerPage);
  const currentItems = invoices.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
useEffect(() => {
  const fetchVisibleQty = async () => {
    const temp = {};

    await Promise.all(
      currentItems.map(async (inv) => {
        if (detailsMap[inv.invoice_id]) return;

        try {
          const res = await fetch(withTokenQuery(`${API_ROOT}/public/api/invoice/details/${inv.invoice_id}`), {
            credentials: 'include'
          });
          const data = await res.json();

          if (data.success) {
            temp[inv.invoice_id] = data;
          }
        } catch (err) {
          console.error(err);
        }
      })
    );

    if (Object.keys(temp).length > 0) {
      setDetailsMap(prev => ({
        ...prev,
        ...temp
      }));
    }
  };

  if (currentItems.length > 0) {
    fetchVisibleQty();
  }
}, [currentItems]);
  const getPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
        pages.push(i);
      } else if (pages.length > 0 && pages[pages.length - 1] !== '...') {
        pages.push('...');
      }
    }
    return pages;
  };

  return (
    <div className="sv-staff-container">
      <header className="sv-simple-header">
        <h2 className="sv-title">Staff Incentive Dashboard</h2>
      </header>

      {/* Filter Bar */}
      <div className="sv-filter-card">
        {apiError && (
          <div style={{ color: '#dc2626', fontWeight: 600, marginBottom: '8px' }}>
            {apiError}
          </div>
        )}
        <div className="filter-wrapper">
          <div className="filter-left">
            <div className="filter-item">
              <label>Staff Member</label>
              <select value={userId} onChange={(e) => setUserId(e.target.value)}>
                {isAdminUser && <option value="">All Staff</option>}
                {users.map(u => (
                  /* Mapping to user_id and user_name as seen in API screenshot */
                  <option key={u.user_id} value={u.user_id}>
                    {u.user_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="filter-item">
              <label>From Date</label>
              <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
            </div>
            <div className="filter-item">
              <label>To Date</label>
              <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
            </div>
          </div>
<button
  disabled={!userId} // ✅ disable if no user selected
  onClick={() => {
    if (!userId) {
      alert("Please select staff member"); // ✅ optional warning
      return;
    }

    navigate(
      `/product-sales-report?user_id=${userId}&from_date=${fromDate}&to_date=${toDate}`
    );
  }}
  style={{
    padding: "8px 14px",
    background: userId ? "#2563eb" : "#9ca3af", // grey when disabled
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: userId ? "pointer" : "not-allowed"
  }}
>
  View Product Report
</button>
          <div className="filter-right">
            <div className="filter-stat">
              <span className="stat-lbl">Count</span>
              <span className="stat-val">{totalCount}</span>
            </div>
            <div className="filter-stat highlight">
              <span className="stat-lbl">Amount</span>
              <span className="stat-val">₹{totalAmount.toLocaleString()}</span>
            </div>
            <button className="reset-btn" onClick={() => { setUserId(''); setFromDate(''); setToDate(''); }}>Reset</button>
            <button
              className="print-btn"
              onClick={() => handlePrint()}
              style={{
                // marginLeft: '20px',
                padding: '6px 12px',
                background: '#5dc9e4',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
              }}
            >
              Print
            </button>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="sv-loader">Loading...</div>
      ) : (
        <>
          {/* <div className="sv-table-wrapper"> */}
          <div id="sv-table-to-print" className="sv-table-wrapper">

            <table className="sv-main-table">
              <thead>
                <tr>
                  <th>S.No</th> {/* 👈 Add this */}
             <th onClick={() => setDateSortOrder(prev => prev === 'asc' ? 'desc' : 'asc')}
    style={{ cursor: 'pointer' }}>
  Date {dateSortOrder === 'asc' ? '↑' : '↓'}
</th>
                  <th>Invoice No.</th>
                  <th>Patient ID</th>
                  <th>Created By</th>
                  <th>Total Qty</th>
                  <th>Description</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((inv, idx) => (
                  <tr key={inv.invoice_id || idx}>
                    <td data-label="S.No">
                      {(currentPage - 1) * itemsPerPage + idx + 1}
                    </td>
                    <td data-label="Date">{inv.invoice_date}</td>
                    <td data-label="Invoice No." className="txt-id">{inv.invoice_no}</td>
                    {/* <td data-label="Patient ID">{inv.invoice_patientid}</td> */}
                    {/* <td data-label="Patient ID">{inv.invoice_patientid}</td> */}
                    <td
                      data-label="Patient ID"
                      style={{ cursor: 'pointer', color: '#dd3232', fontWeight: '600' }}
                      onClick={() => navigate(`/patient/details/${inv.invoice_patientid}`)}
                    >
                      {inv.invoice_patientid}
                    </td>
                    <td data-label="Created By">{inv.created_by}</td>
                    <td data-label="Total Qty" style={{ fontWeight: '700', color: '#13151b' }}>
                      {detailsMap[inv.invoice_id]?.summary?.total_quantity ?? '-'}
                    </td>

                    {/* ✅ Description Button */}
                    <td>
                      <button
                        onClick={() => fetchInvoiceDetails(inv.invoice_id)}
                        style={{
                          padding: '5px 10px',
                          background: '#10b981',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer'
                        }}
                      >
                        View
                      </button>
                    </td>
                    <td data-label="Amount" className="txt-amount">₹{inv.invoice_amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {showModal && invoiceDetails && (
              <div className="modal-overlay">
                <div className="modal-box">
                  <h3>Invoice Details</h3>

                  <p><strong>Invoice No:</strong> {invoiceDetails?.invoice?.invoice_no}</p>
                  <p><strong>Date:</strong> {invoiceDetails?.invoice?.invoice_date}</p>
                  <p><strong>Created By:</strong> {invoiceDetails?.invoice?.created_by}</p>

                  <table className="modal-table">
                    <thead>
                      <tr>
                        <th>Product</th>
                        <th>Qty</th>
                        <th>Amount</th>
                        <th>Discount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invoiceDetails?.items?.map((item, i) => (
                        <tr key={i}>
                          <td data-label="Product">{item.product}</td>
                          <td data-label="Qty">{item.quantity}</td>
                          <td data-label="Amount">₹{item.amount}</td>
                          <td data-label="Discount">{item.discount}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <h4>Total Qty: {invoiceDetails?.summary?.total_quantity}</h4>
                  <h4>Total Amount: ₹{invoiceDetails?.summary?.calculated_total}</h4>

                  <button onClick={() => setShowModal(false)}>Close</button>
                </div>
              </div>
            )}
          </div>

          {/* Pagination Controls */}
          {totalPages > 1 && (
            <div className="sv-pagination">
              <button className="pag-btn" onClick={() => setCurrentPage(p => p - 1)} disabled={currentPage === 1}>Prev</button>
              <div className="pag-list">
                {getPageNumbers().map((num, i) => (
                  <button
                    key={i}
                    onClick={() => num !== '...' && setCurrentPage(num)}
                    className={`pag-btn ${currentPage === num ? 'active' : ''} ${num === '...' ? 'dots' : ''}`}
                    disabled={num === '...'}
                  >
                    {num}
                  </button>
                ))}
              </div>
              <button className="pag-btn" onClick={() => setCurrentPage(p => p + 1)} disabled={currentPage === totalPages}>Next</button>
            </div>
          )}
        </>
      )}

      <style jsx>{`
        /* Styles remain consistent with your previous layout requirements */
        .sv-staff-container { padding: 20px; margin-left: 230px; background: #f8fafc; min-height: 100vh; font-family: sans-serif; }
        .sv-filter-card { background: white; padding: 15px; border-radius: 12px; margin-bottom: 20px; border: 1px solid #e2e8f0; }
        .filter-wrapper { display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 15px; }
        .filter-left { display: flex; gap: 10px; flex-wrap: wrap; }
        .filter-item { display: flex; flex-direction: column; gap: 4px; }
        .filter-item label { font-size: 10px; font-weight: 700; color: #94a3b8; text-transform: uppercase; }
        .filter-item select, .filter-item input { padding: 1px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 13px; }
        .filter-right { display: flex; align-items: center; gap: 15px; }
        .filter-stat { display: flex; flex-direction: column; text-align: right; }
        .stat-lbl { font-size: 10px; font-weight: 800; color: #64748b; }
        .stat-val { font-size: 16px; font-weight: 800; color: seagreen; }
        .reset-btn { padding: 8px 15px; background: #ef4444; color: white; border: none; border-radius: 6px; cursor: pointer; font-weight: 600; }

        .sv-table-wrapper { background: white; border-radius: 10px; overflow: hidden; border: 1px solid #e2e8f0; }
        .sv-main-table { width: 100%; border-collapse: collapse; }
        .sv-main-table th { background: #f8fafc; padding: 12px; text-align: center; font-size: 11px; color: #64748b; text-transform: uppercase; }
        .sv-main-table td { padding: 12px; border-bottom: 1px solid #f1f5f9; font-size: 14px; }
        .txt-id { font-weight: 600; color: #2fb2e7; }
        .txt-amount { font-weight: 700; color: #10b981; }

        .sv-pagination { display: flex; justify-content: center;margin-bottom:30px; align-items: center; margin-top: 20px; gap: 5px; }
        .pag-btn { padding: 6px 10px; background: white; border: 1px solid #e2e8f0; border-radius: 4px; cursor: pointer; }
        .pag-btn.active { background: #2563eb; color: white; }

        @media (max-width: 1024px) {
          .sv-staff-container { margin-left: 0; padding: 10px; }
          .filter-wrapper { flex-direction: column; align-items: stretch; }
          .filter-right { border-top: 1px solid #eee; padding-top: 10px; justify-content: space-between; }
          .sv-main-table thead { display: none; }
          .sv-main-table tr { display: block; margin-bottom: 10px; border: 1px solid #e2e8f0; border-radius: 8px; background: #fff; }
          .sv-main-table td { display: flex; justify-content: space-between; align-items: center; padding: 10px 15px; border-bottom: 1px solid #f8fafc; }
          .sv-main-table td::before { content: attr(data-label); font-weight: 700; color: #64748b; font-size: 11px; text-transform: uppercase; }
        }
          .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-box {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  width: 600px;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.modal-table th, .modal-table td {
  border: 1px solid #ddd;
  padding: 8px;
}
      `}</style>
    </div>
  );
};

export default Staff;